import React from "react";

const MarkedIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.19922 10.5071L6.82422 14.821L16.1992 1.39999"
        stroke={fill}
        strokeWidth="3.94737"
      />
    </svg>
  );
};

MarkedIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: "#333333",
};

export default MarkedIcon;
